var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83344 2.66667L6.50011 1M6.50011 1L8.16678 2.66667M6.50011 1V6.55556M3.72246 4.88889C3.20475 4.88889 2.94589 4.88889 2.7417 4.97347C2.46945 5.08624 2.25301 5.30267 2.14024 5.57492C2.05566 5.77911 2.05566 6.03784 2.05566 6.55556V9.22222C2.05566 9.8445 2.05566 10.1554 2.17677 10.3931C2.28329 10.6022 2.45315 10.7725 2.66222 10.879C2.89967 11 3.21066 11 3.83173 11H9.16876C9.78983 11 10.1004 11 10.3378 10.879C10.5469 10.7725 10.717 10.6022 10.8236 10.3931C10.9446 10.1557 10.9446 9.845 10.9446 9.22394V6.55556C10.9446 6.03784 10.9445 5.77911 10.8599 5.57492C10.7471 5.30267 10.5309 5.08624 10.2586 4.97347C10.0545 4.88889 9.7956 4.88889 9.27789 4.88889",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.895d16df38146aeb431c8a45068c0b33.svg";
export { ForwardRef as ReactComponent };